
import { cn } from "../lib/utils";

function Characterization( { className, ...props } ) {

  return (

    <div

      className={ cn( "border border-grey-smoke shadow-xs h-max", className ) }

      { ...props }

    />

  )

}

function CharacterizationBlurb( { className, ...props } ) {

  return (

    <p

      className={ cn( "text-sm/tight pt-1 pb-3", className ) }

      { ...props }

    />

  )

}

function CharacterizationContent( { className, ...props } ) {

  return (

    <div

      className={ cn( "border-t-8 border-blue-primary text-center px-4 py-5", className ) }

      { ...props }

    />

  )

}

function CharacterizationHeader( { className, ...props } ) {
  
  return (

    <div

      className={ cn( "font-bold text-xl/tight text-[#373737]", className ) }

      { ...props }

    />

  )

}

function CharacterizationLink( { className, ...props } ) {
  
  return (

    <a

      className={ cn( "inline-block font-bold text-sm/snug text-blue-fresh hover:underline", className ) }

      href="https://info.biomerieux.com/clin_us_2025_lab-optimization-consultancy_talk-to-sales"

      target="_blank"

      { ...props }

    />

  )

}

export {

  Characterization,

  CharacterizationContent,
  
  CharacterizationHeader,

  CharacterizationLink,
  
  CharacterizationBlurb,
  
}
